import { render, staticRenderFns } from "./OrgSettingsCriteriaLibrary.vue?vue&type=template&id=370a6320&scoped=true&"
import script from "./OrgSettingsCriteriaLibrary.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsCriteriaLibrary.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsCriteriaLibrary.vue?vue&type=style&index=0&id=370a6320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a6320",
  null
  
)

export default component.exports